// plop_marker:layouts_import
import ScrollParallaxHomepageFirstFold from "./scroll-parallax-homepage-first-fold";
import GlobeWithTopCtaHomepageFirstFold from "./globe-with-top-cta-homepage-first-fold";
import GlobeHomepageFirstFold from "./globe-homepage-first-fold";
import AnimatingBoardHomepageFirstFold from "./animating-board-homepage-first-fold";

export default {
  // plop_marker:layouts_add_layout
  ScrollParallaxHomepageFirstFold,
  GlobeWithTopCtaHomepageFirstFold,
  GlobeHomepageFirstFold,
  AnimatingBoardHomepageFirstFold,
};
